// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "billing/v1/billing.proto" (package "billing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Billing proto is defined privately within app, separate from public API,
// because it represents Viam-specific billing implementation and integration with Stripe
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BillingService } from "./billing";
import type { GetRegistryItemServicePeriodResponse } from "./billing";
import type { GetRegistryItemServicePeriodRequest } from "./billing";
import type { GetMonthlyBillingAlertThresholdResponse } from "./billing";
import type { GetMonthlyBillingAlertThresholdRequest } from "./billing";
import type { DeleteMonthlyBillingAlertThresholdResponse } from "./billing";
import type { DeleteMonthlyBillingAlertThresholdRequest } from "./billing";
import type { SetMonthlyBillingAlertThresholdResponse } from "./billing";
import type { SetMonthlyBillingAlertThresholdRequest } from "./billing";
import type { GetOrgBillingInfoResponse } from "./billing";
import type { GetOrgBillingInfoRequest } from "./billing";
import type { GetMachinesWithBillableFragmentsResponse } from "./billing";
import type { GetMachinesWithBillableFragmentsRequest } from "./billing";
import type { GetCustomBillingMetadataResponse } from "./billing";
import type { GetCustomBillingMetadataRequest } from "./billing";
import type { ReplaceFragmentResponse } from "./billing";
import type { ReplaceFragmentRequest } from "./billing";
import type { RemoveOrganizationBillingInfoResponse } from "./billing";
import type { RemoveOrganizationBillingInfoRequest } from "./billing";
import type { CreateStripePaymentIntentResponse } from "./billing";
import type { CreateStripePaymentIntentRequest } from "./billing";
import type { CreateStripeSetupIntentResponse } from "./billing";
import type { CreateStripeSetupIntentRequest } from "./billing";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { FinalizeAmountDueResponse } from "./billing";
import type { FinalizeAmountDueRequest } from "./billing";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service billing.v1.BillingService
 */
export interface IBillingServiceClient {
    /**
     * Finalizes amount due (including tax calculation)
     *
     * @generated from protobuf rpc: FinalizeAmountDue(billing.v1.FinalizeAmountDueRequest) returns (billing.v1.FinalizeAmountDueResponse);
     */
    finalizeAmountDue(input: FinalizeAmountDueRequest, options?: RpcOptions): UnaryCall<FinalizeAmountDueRequest, FinalizeAmountDueResponse>;
    /**
     * Create a Stripe setup intent
     * - Sets up a Stripe setup intent to be confirmed after payment method is input via elements
     * - Sets up a payment method for deferred charges
     *
     * @generated from protobuf rpc: CreateStripeSetupIntent(billing.v1.CreateStripeSetupIntentRequest) returns (billing.v1.CreateStripeSetupIntentResponse);
     */
    createStripeSetupIntent(input: CreateStripeSetupIntentRequest, options?: RpcOptions): UnaryCall<CreateStripeSetupIntentRequest, CreateStripeSetupIntentResponse>;
    /**
     * Create a Stripe payment intent
     * - Creates a payment intent to be confirmed after payment method is input via elements
     * - Charges payment method when the payment intent is confirmed
     *
     * @generated from protobuf rpc: CreateStripePaymentIntent(billing.v1.CreateStripePaymentIntentRequest) returns (billing.v1.CreateStripePaymentIntentResponse);
     */
    createStripePaymentIntent(input: CreateStripePaymentIntentRequest, options?: RpcOptions): UnaryCall<CreateStripePaymentIntentRequest, CreateStripePaymentIntentResponse>;
    /**
     * @generated from protobuf rpc: RemoveOrganizationBillingInfo(billing.v1.RemoveOrganizationBillingInfoRequest) returns (billing.v1.RemoveOrganizationBillingInfoResponse);
     */
    removeOrganizationBillingInfo(input: RemoveOrganizationBillingInfoRequest, options?: RpcOptions): UnaryCall<RemoveOrganizationBillingInfoRequest, RemoveOrganizationBillingInfoResponse>;
    /**
     * @generated from protobuf rpc: ReplaceFragment(billing.v1.ReplaceFragmentRequest) returns (billing.v1.ReplaceFragmentResponse);
     */
    replaceFragment(input: ReplaceFragmentRequest, options?: RpcOptions): UnaryCall<ReplaceFragmentRequest, ReplaceFragmentResponse>;
    /**
     * Get information about the custom billing view for the given namespace.
     *
     * @generated from protobuf rpc: GetCustomBillingMetadata(billing.v1.GetCustomBillingMetadataRequest) returns (billing.v1.GetCustomBillingMetadataResponse);
     */
    getCustomBillingMetadata(input: GetCustomBillingMetadataRequest, options?: RpcOptions): UnaryCall<GetCustomBillingMetadataRequest, GetCustomBillingMetadataResponse>;
    /**
     * Gets all machines in an org with the specified billable fragment ids
     *
     * @generated from protobuf rpc: GetMachinesWithBillableFragments(billing.v1.GetMachinesWithBillableFragmentsRequest) returns (billing.v1.GetMachinesWithBillableFragmentsResponse);
     */
    getMachinesWithBillableFragments(input: GetMachinesWithBillableFragmentsRequest, options?: RpcOptions): UnaryCall<GetMachinesWithBillableFragmentsRequest, GetMachinesWithBillableFragmentsResponse>;
    /**
     * @generated from protobuf rpc: GetOrgBillingInfo(billing.v1.GetOrgBillingInfoRequest) returns (billing.v1.GetOrgBillingInfoResponse);
     */
    getOrgBillingInfo(input: GetOrgBillingInfoRequest, options?: RpcOptions): UnaryCall<GetOrgBillingInfoRequest, GetOrgBillingInfoResponse>;
    /**
     * Set the monthly billing alert threshold for an organization
     *
     * @generated from protobuf rpc: SetMonthlyBillingAlertThreshold(billing.v1.SetMonthlyBillingAlertThresholdRequest) returns (billing.v1.SetMonthlyBillingAlertThresholdResponse);
     */
    setMonthlyBillingAlertThreshold(input: SetMonthlyBillingAlertThresholdRequest, options?: RpcOptions): UnaryCall<SetMonthlyBillingAlertThresholdRequest, SetMonthlyBillingAlertThresholdResponse>;
    /**
     * Delete the monthly billing alert threshold for an organization
     *
     * @generated from protobuf rpc: DeleteMonthlyBillingAlertThreshold(billing.v1.DeleteMonthlyBillingAlertThresholdRequest) returns (billing.v1.DeleteMonthlyBillingAlertThresholdResponse);
     */
    deleteMonthlyBillingAlertThreshold(input: DeleteMonthlyBillingAlertThresholdRequest, options?: RpcOptions): UnaryCall<DeleteMonthlyBillingAlertThresholdRequest, DeleteMonthlyBillingAlertThresholdResponse>;
    /**
     * Get the monthly billing alert threshold for an organization
     *
     * @generated from protobuf rpc: GetMonthlyBillingAlertThreshold(billing.v1.GetMonthlyBillingAlertThresholdRequest) returns (billing.v1.GetMonthlyBillingAlertThresholdResponse);
     */
    getMonthlyBillingAlertThreshold(input: GetMonthlyBillingAlertThresholdRequest, options?: RpcOptions): UnaryCall<GetMonthlyBillingAlertThresholdRequest, GetMonthlyBillingAlertThresholdResponse>;
    /**
     * Get the current service period (start/end dates) for a registry item's usage on a robot part
     *
     * @generated from protobuf rpc: GetRegistryItemServicePeriod(billing.v1.GetRegistryItemServicePeriodRequest) returns (billing.v1.GetRegistryItemServicePeriodResponse);
     */
    getRegistryItemServicePeriod(input: GetRegistryItemServicePeriodRequest, options?: RpcOptions): UnaryCall<GetRegistryItemServicePeriodRequest, GetRegistryItemServicePeriodResponse>;
}
/**
 * @generated from protobuf service billing.v1.BillingService
 */
export class BillingServiceClient implements IBillingServiceClient, ServiceInfo {
    typeName = BillingService.typeName;
    methods = BillingService.methods;
    options = BillingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Finalizes amount due (including tax calculation)
     *
     * @generated from protobuf rpc: FinalizeAmountDue(billing.v1.FinalizeAmountDueRequest) returns (billing.v1.FinalizeAmountDueResponse);
     */
    finalizeAmountDue(input: FinalizeAmountDueRequest, options?: RpcOptions): UnaryCall<FinalizeAmountDueRequest, FinalizeAmountDueResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<FinalizeAmountDueRequest, FinalizeAmountDueResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a Stripe setup intent
     * - Sets up a Stripe setup intent to be confirmed after payment method is input via elements
     * - Sets up a payment method for deferred charges
     *
     * @generated from protobuf rpc: CreateStripeSetupIntent(billing.v1.CreateStripeSetupIntentRequest) returns (billing.v1.CreateStripeSetupIntentResponse);
     */
    createStripeSetupIntent(input: CreateStripeSetupIntentRequest, options?: RpcOptions): UnaryCall<CreateStripeSetupIntentRequest, CreateStripeSetupIntentResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateStripeSetupIntentRequest, CreateStripeSetupIntentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a Stripe payment intent
     * - Creates a payment intent to be confirmed after payment method is input via elements
     * - Charges payment method when the payment intent is confirmed
     *
     * @generated from protobuf rpc: CreateStripePaymentIntent(billing.v1.CreateStripePaymentIntentRequest) returns (billing.v1.CreateStripePaymentIntentResponse);
     */
    createStripePaymentIntent(input: CreateStripePaymentIntentRequest, options?: RpcOptions): UnaryCall<CreateStripePaymentIntentRequest, CreateStripePaymentIntentResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateStripePaymentIntentRequest, CreateStripePaymentIntentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveOrganizationBillingInfo(billing.v1.RemoveOrganizationBillingInfoRequest) returns (billing.v1.RemoveOrganizationBillingInfoResponse);
     */
    removeOrganizationBillingInfo(input: RemoveOrganizationBillingInfoRequest, options?: RpcOptions): UnaryCall<RemoveOrganizationBillingInfoRequest, RemoveOrganizationBillingInfoResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveOrganizationBillingInfoRequest, RemoveOrganizationBillingInfoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReplaceFragment(billing.v1.ReplaceFragmentRequest) returns (billing.v1.ReplaceFragmentResponse);
     */
    replaceFragment(input: ReplaceFragmentRequest, options?: RpcOptions): UnaryCall<ReplaceFragmentRequest, ReplaceFragmentResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReplaceFragmentRequest, ReplaceFragmentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get information about the custom billing view for the given namespace.
     *
     * @generated from protobuf rpc: GetCustomBillingMetadata(billing.v1.GetCustomBillingMetadataRequest) returns (billing.v1.GetCustomBillingMetadataResponse);
     */
    getCustomBillingMetadata(input: GetCustomBillingMetadataRequest, options?: RpcOptions): UnaryCall<GetCustomBillingMetadataRequest, GetCustomBillingMetadataResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomBillingMetadataRequest, GetCustomBillingMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets all machines in an org with the specified billable fragment ids
     *
     * @generated from protobuf rpc: GetMachinesWithBillableFragments(billing.v1.GetMachinesWithBillableFragmentsRequest) returns (billing.v1.GetMachinesWithBillableFragmentsResponse);
     */
    getMachinesWithBillableFragments(input: GetMachinesWithBillableFragmentsRequest, options?: RpcOptions): UnaryCall<GetMachinesWithBillableFragmentsRequest, GetMachinesWithBillableFragmentsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMachinesWithBillableFragmentsRequest, GetMachinesWithBillableFragmentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetOrgBillingInfo(billing.v1.GetOrgBillingInfoRequest) returns (billing.v1.GetOrgBillingInfoResponse);
     */
    getOrgBillingInfo(input: GetOrgBillingInfoRequest, options?: RpcOptions): UnaryCall<GetOrgBillingInfoRequest, GetOrgBillingInfoResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrgBillingInfoRequest, GetOrgBillingInfoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Set the monthly billing alert threshold for an organization
     *
     * @generated from protobuf rpc: SetMonthlyBillingAlertThreshold(billing.v1.SetMonthlyBillingAlertThresholdRequest) returns (billing.v1.SetMonthlyBillingAlertThresholdResponse);
     */
    setMonthlyBillingAlertThreshold(input: SetMonthlyBillingAlertThresholdRequest, options?: RpcOptions): UnaryCall<SetMonthlyBillingAlertThresholdRequest, SetMonthlyBillingAlertThresholdResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetMonthlyBillingAlertThresholdRequest, SetMonthlyBillingAlertThresholdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete the monthly billing alert threshold for an organization
     *
     * @generated from protobuf rpc: DeleteMonthlyBillingAlertThreshold(billing.v1.DeleteMonthlyBillingAlertThresholdRequest) returns (billing.v1.DeleteMonthlyBillingAlertThresholdResponse);
     */
    deleteMonthlyBillingAlertThreshold(input: DeleteMonthlyBillingAlertThresholdRequest, options?: RpcOptions): UnaryCall<DeleteMonthlyBillingAlertThresholdRequest, DeleteMonthlyBillingAlertThresholdResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteMonthlyBillingAlertThresholdRequest, DeleteMonthlyBillingAlertThresholdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get the monthly billing alert threshold for an organization
     *
     * @generated from protobuf rpc: GetMonthlyBillingAlertThreshold(billing.v1.GetMonthlyBillingAlertThresholdRequest) returns (billing.v1.GetMonthlyBillingAlertThresholdResponse);
     */
    getMonthlyBillingAlertThreshold(input: GetMonthlyBillingAlertThresholdRequest, options?: RpcOptions): UnaryCall<GetMonthlyBillingAlertThresholdRequest, GetMonthlyBillingAlertThresholdResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMonthlyBillingAlertThresholdRequest, GetMonthlyBillingAlertThresholdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get the current service period (start/end dates) for a registry item's usage on a robot part
     *
     * @generated from protobuf rpc: GetRegistryItemServicePeriod(billing.v1.GetRegistryItemServicePeriodRequest) returns (billing.v1.GetRegistryItemServicePeriodResponse);
     */
    getRegistryItemServicePeriod(input: GetRegistryItemServicePeriodRequest, options?: RpcOptions): UnaryCall<GetRegistryItemServicePeriodRequest, GetRegistryItemServicePeriodResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRegistryItemServicePeriodRequest, GetRegistryItemServicePeriodResponse>("unary", this._transport, method, opt, input);
    }
}
